// Module
var code = "<div class=\"widget\">\n  <div class=\"modal-header\">\n    <button type=\"button\" class=\"close\" ng-click=\"close($event)\"><span>&times;</span></button>\n    <h1 class=\"modal-title\" translate>{{ 'app.shared.calendar.filter_calendar' }}</h1>\n  </div>\n  <div class=\"modal-body widget-content calendar-filter calendar-filter-aside\">\n    <ng-include src=\"'/calendar/filter.html'\"></ng-include>\n  </div>\n</div>\n";
// Exports
var _module_exports = code;;
var path = '/calendar/filterAside.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;